/**
 * State options for JInspector state dropdown.
 * Mirrors JournalStates — Active=0, Completed=1.
 */
export const STATE_OPTIONS = [
    { label: 'Active', value: 0 },
    { label: 'Completed', value: 1 },
    { label: 'Approved', value: 100 },
];
